var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collectionEngineV1 } from '../apis';
const workflowsAPI = collectionEngineV1('/workflows');
export const get = (casualConsistency) => workflowsAPI('GET', `/${casualConsistency ? '?casualConsistency=true' : ''}`);
export const getById = (id) => workflowsAPI('GET', `/${id}`);
export const create = (newWorkflow) => workflowsAPI('POST', '/', { body: newWorkflow });
export const update = (workflowId, updateWorkflow) => workflowsAPI('PATCH', `/${workflowId}`, { body: updateWorkflow });
export const duplicateWorkflow = (workflowId) => workflowsAPI('POST', `/duplicate/${workflowId}`);
export const runTask = (workflowId, caseId, taskId) => workflowsAPI('POST', `/${workflowId}/${caseId}/run/${taskId}`);
export const rollback = (caseId, updateId) => workflowsAPI('POST', `/${caseId}/rollback/${updateId}`);
export const getStats = (workflowId, caseFilter) => __awaiter(void 0, void 0, void 0, function* () {
    if (workflowId === null) {
        return null;
    }
    return workflowsAPI('POST', `/stats/${workflowId}`, {
        body: { caseFilter },
    });
});
export const getTaskStats = (workflowId, taskId, caseFilter) => workflowsAPI('POST', `/stats/${workflowId}/${taskId}`, {
    body: { caseFilter },
});
//# sourceMappingURL=workflows.js.map